<script>
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    count: {
      type: String,
      default: '',
    },
    isChildMenuActive: {
      type: Boolean,
      default: false,
    },
    openInNewPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isExternalUrl() {
      return (
        this.to &&
        (this.to.startsWith('http://') || this.to.startsWith('https://'))
      );
    },
  },
};
</script>

<template>
  <a
    v-if="isExternalUrl"
    v-tooltip.right="{
      content: $t(`SIDEBAR.${name}`),
      classes: 'nav-rail-tooltip',
      boundariesElement: 'window',
    }"
    :href="to"
    class="text-slate-700 dark:text-slate-100 w-10 h-10 my-2 flex items-center justify-center rounded-lg hover:bg-gray-gray-2 dark:hover:bg-dark-dark-4 dark:hover:text-basic-primaryText hover:text-basic-primaryText relative"
    :rel="openInNewPage ? 'noopener noreferrer' : undefined"
    :target="openInNewPage ? '_blank' : undefined"
  >
    <fluent-icon-v2
      :icon="icon"
      :class="{
        'text-basic-secondary': isChildMenuActive,
      }"
    />
    <span class="sr-only">{{ name }}</span>
    <span
      v-if="count"
      class="text-black-900 bg-yellow-500 absolute -top-1 -right-1"
    >
      {{ count }}
    </span>
  </a>

  <router-link v-else v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip.right="{
        content: $t(`SIDEBAR.${name}`),
        classes: 'nav-rail-tooltip',
        boundariesElement: 'window',
      }"
      :href="href"
      class="text-slate-700 dark:text-slate-100 w-10 h-10 my-2 flex items-center justify-center rounded-lg hover:bg-gray-gray-2 dark:hover:bg-dark-dark-4 dark:hover:text-basic-primaryText hover:text-basic-primaryText relative"
      :class="{
        'bg-orange-light-4 dark:bg-orange-dark-4 text-basic-secondary hover:bg-orange-light-4 dark:hover:bg-orange-dark-4':
          isActive || isChildMenuActive,
      }"
      @click="navigate"
    >
      <fluent-icon-v2
        :icon="icon"
        :class="{
          'text-basic-secondary': isActive || isChildMenuActive,
        }"
      />
      <span class="sr-only">{{ name }}</span>
      <span
        v-if="count"
        class="text-black-900 bg-yellow-500 absolute -top-1 -right-1"
      >
        {{ count }}
      </span>
    </a>
  </router-link>
</template>
